<template>
  <v-app>
    <v-main>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    isLogind: false,
  }),
  head: {
    // 全画面共通で使用するmetaの一覧
    meta: function () {
      return [
        // キャッシュの使用をしない設定
        { "http-equiv": "Pragma", content: "no-cache" },
        // 中間サーバとブラウザによる私用キャッシュを無しに設定
        { "http-equiv": "Cache-Control", content: "no-cache" },
        // 画面に表示した時からのキャッシュの有効時間を0秒に設定
        { "http-equiv": "Expires", content: 0 },
        // ...
      ];
    },
  },
  methods: {},
  computed: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
